module.exports = __webpack_public_path__ + "img/VIP SELECTION.2d4d6824.jpg";